import { create } from 'mobx-persist';

export const hydrateMobX = create({ debounce: 500 });
